import { render } from "./ventanaemergente.vue?vue&type=template&id=3abd3846&scoped=true"
import script from "./ventanaemergente.vue?vue&type=script&lang=js"
export * from "./ventanaemergente.vue?vue&type=script&lang=js"

import "./ventanaemergente.vue?vue&type=style&index=0&id=3abd3846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abd3846"]])

export default __exports__